module.exports = __webpack_public_path__ + "img/header-diamondJewelryBudgetHigh@2x.7a22c4d.webp";